import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import InputRange from './InputRange'
import { convertToRange } from '../../../helpers/util'

class InputRangeWithConvert extends PureComponent {
  static defaultProps = {
    roundBy: 100,
    initActiveTrackPos: 0,
    onFocus: () => {},
    disabled: false
  }

  static propTypes = {
    visualMin: PropTypes.number.isRequired,
    visualMax: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    initActiveTrackPos: PropTypes.number,
    roundBy: PropTypes.number,
    onFocus: PropTypes.func,
    disabled: PropTypes.bool,
  }

  onChange = (value) => {
    this.props.onChange(this.convert(value))
  }

  onClick = (value) => {
    this.props.onClick(this.convert(value))
  }

  convert = (value) => {
    const {
      roundBy,
      min,
      max,
      visualMin,
      visualMax
    } = this.props
    let convertedValue = value

    if (value < 0) {
      convertedValue = convertToRange(value, [visualMin, 0], [min, 0])
    } else if (value > 0) {
      convertedValue = convertToRange(value, [0, visualMax], [0, max])
    }

    return Math.round(convertedValue * roundBy) / roundBy
  }

  render() {
    const {
      value,
      initActiveTrackPos,
      roundBy,
      disabled,
      visualMin,
      visualMax,
      onFocus
    } = this.props

    return (
      <InputRange
        value={value}
        initActiveTrackPos={initActiveTrackPos}
        roundBy={roundBy}
        disabled={disabled}
        min={visualMin}
        max={visualMax}
        onFocus={onFocus}
        onChange={this.onChange}
        onClick={this.onClick}
      />
    )
  }
}

export default InputRangeWithConvert
